import React from 'react'
import './About.css'
import ME from '../../assets/img2.jpeg' 
import {FaAward} from 'react-icons/fa'
import {FiUsers} from 'react-icons/fi'
import {VscFolderLibrary} from 'react-icons/vsc'

const About = () => {
    return (
        <section id="about">
           <h5>GET TO KNOW</h5>
           <h2>About Me </h2>
           <div className="container about_container">
               <div className='about_me'>
                   <div className="about-me-img">
                   <img src={ME} alt="" className='img-91' />
                   </div>
               </div>
               <div className="about_content">
                   <div className="about_cards">
                       <article className='about_card'>
                           <FaAward className='about_icons'/>
                           <h5>Experience</h5>
                           <small>2+ Years of Working </small>
                       </article>
                       <article className='about_card'>
                           <FiUsers className='about_icons'/>
                           <h5>Clients</h5>
                           <small>150+ Happy Customers Worldwide</small>
                       </article>
                       <article className='about_card'>
                           <VscFolderLibrary className='about_icons'/>
                           <h5>Projects</h5>
                           <small>90+ Completed</small>
                       </article>
                   </div>
                   <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Explicabo nesciunt quo molestiae error modi necessitatibus, dolorum eveniet, possimus similique ullam, corrupti quisquam? Laboriosam quidem aliquid dolorem. Eligendi autem voluptas sunt, nobis nesciunt maiores sit dolorum distinctio beatae labore quo eius quae, quibusdam hic illo ad.</p>
                   <a href="#contact" className='btn btn-primary'>Let's Talk</a>
               </div>
           </div>
    </section>
    )
}

export default About
